const ua = navigator.userAgent.toLowerCase();
const isAndroid = ua.indexOf('android') > -1; // && ua.indexOf("mobile");

if (isAndroid) {
  $('body').addClass('android');
}

if (!$('body').hasClass('IE8')) {
  // Listen for orientation changes
  // fixes bug on ipad
  window.addEventListener('orientationchange', () => {
    $('body').fadeOut(1, () => {
      $('body').fadeIn(1);
    });
  });

  if (isiPad()) {
    $('body').addClass('iPad');

    if ((window.orientation) === 90) {
      $('body').addClass('iPad-horizontal');
    } else {
      $('body').removeClass('iPad-horizontal');
    }
  }

  if (isiPhone()) {
    $('body').addClass('iPhone');

    if ((window.orientation) === 90) {
      $('body').addClass('iPhone-horizontal');
    } else {
      $('body').removeClass('iPhone-horizontal');
    }

    // Listen for orientation changes
    window.addEventListener('orientationchange', () => {
      // Announce the new orientation number
      if ((window.orientation) === 90) {
        $('body').addClass('iPhone-horizontal');
      } else {
        $('body').removeClass('iPhone-horizontal');
      }
    }, false);
  }

  $(window).resize(() => {
    if ($(window).innerWidth() > 767) {
      if ($('body').hasClass('iPhone-horizontal')) {
        $('body').removeClass('iPhone-horizontal');
      }
    } else {
      if (isiPhone()) {
        if (!$('body').hasClass('iPhone')) {
          $('body').addClass('iPhone');
        }

        if ((window.orientation) === 90) {
          $('body').addClass('iPhone-horizontal');
        } else {
          $('body').removeClass('iPhone-horizontal');
        }
      }

      if (isiPad()) {
        if (!$('body').hasClass('iPad')) {
          $('body').addClass('iPad');
        }

        if ((window.orientation) === 90) {
          $('body').addClass('iPad-horizontal');
        } else {
          $('body').removeClass('iPad-horizontal');
        }
      }
    }
  });
}

function isiPhone() {
  return (
    (navigator.platform.indexOf('iPhone') !== -1) ||
    (navigator.platform.indexOf('iPod') !== -1)
  );
}

function isiPad() {
  return ((navigator.platform.indexOf('iPad') !== -1));
}
